export const NOMBRE_COLEGIO_ACTUALIZADO = 'docente:nombre-colegio';

// Una respuesta tardía de otra sesión o institución nunca modifica la actual.
export const aplicarNombreColegio = (respuesta, token, colegioID, storage = localStorage) => {
  if (!respuesta?.valido || respuesta.sesion?.ColegioID !== colegioID ||
      storage.getItem('docente_token') !== token ||
      storage.getItem('colegio_seleccionado') !== colegioID ||
      typeof respuesta.nombreColegio !== 'string' || !respuesta.nombreColegio.trim()) return false;
  const nombre = respuesta.nombreColegio.trim();
  storage.setItem('nombre_colegio', nombre);
  try {
    const colegios = JSON.parse(storage.getItem('docente_colegios') || '[]');
    if (Array.isArray(colegios)) {
      storage.setItem('docente_colegios', JSON.stringify(colegios.map(c =>
        c.colegioID === colegioID ? { ...c, nombreColegio: nombre } : c)));
    }
  } catch { /* Una lista antigua inválida no impide actualizar el nombre. */ }
  return true;
};
